import React from "react";
import {
  Box,
  Container,
  Grid,
  Skeleton,
  Stack,
  styled,
  Divider,
} from "@mui/material";

const SkeletonWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: "background.paper",
  padding: theme.spacing(4, 0),
}));

const BookDetailsSkeleton = () => {
  return (
    <SkeletonWrapper>
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          {/* Left Side */}
          <Grid item xs={12} md={8}>
            <Box sx={{ display: "flex", gap: 3, mb: 4 }}>
              {/* Book Image */}
              <Skeleton
                variant="rectangular"
                width={150}
                height={200}
                sx={{ borderRadius: 1 }}
              />

              {/* Book Info */}
              <Box sx={{ flex: 1 }}>
                <Skeleton
                  variant="text"
                  height={40}
                  width="80%"
                  sx={{ mb: 1 }}
                />
                <Skeleton
                  variant="text"
                  height={24}
                  width={120}
                  sx={{ mb: 1 }}
                />
                <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
                  <Skeleton variant="text" width={40} />
                  <Skeleton variant="text" width={80} />
                  <Skeleton variant="text" width={80} />
                </Stack>
                <Skeleton variant="text" width={200} />
              </Box>
            </Box>

            {/* Action Buttons */}
            <Stack direction="row" spacing={2} sx={{ mb: 4 }}>
              <Skeleton
                variant="rectangular"
                width={180}
                height={36}
                sx={{ borderRadius: 1 }}
              />
              <Skeleton
                variant="rectangular"
                width={140}
                height={36}
                sx={{ borderRadius: 1 }}
              />
              <Skeleton
                variant="rectangular"
                width={160}
                height={36}
                sx={{ borderRadius: 1 }}
              />
            </Stack>

            {/* Key Benefits */}
            <Skeleton variant="text" height={32} width={140} sx={{ mb: 2 }} />
            {[1, 2, 3].map((item) => (
              <Box key={item} sx={{ display: "flex", gap: 1, mb: 2 }}>
                <Skeleton variant="circular" width={20} height={20} />
                <Skeleton variant="text" height={24} width="90%" />
              </Box>
            ))}

            {/* Description */}
            <Box sx={{ mt: 4 }}>
              <Skeleton variant="text" height={32} width={140} sx={{ mb: 2 }} />
              <Skeleton
                variant="rectangular"
                height={120}
                sx={{ borderRadius: 1 }}
              />
            </Box>
          </Grid>

          {/* Right Side */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                p: 3,
                border: 1,
                borderColor: "divider",
                borderRadius: 1,
              }}
            >
              <Skeleton variant="text" height={32} width={200} sx={{ mb: 2 }} />
              {[1, 2, 3, 4, 5].map((item) => (
                <Box key={item} sx={{ display: "flex", gap: 1, mb: 2 }}>
                  <Skeleton variant="circular" width={20} height={20} />
                  <Skeleton variant="text" height={24} width="90%" />
                </Box>
              ))}

              <Divider sx={{ my: 2 }} />

              <Skeleton
                variant="rectangular"
                height={72}
                sx={{ borderRadius: 1, mb: 2 }}
              />

              <Skeleton
                variant="rectangular"
                height={48}
                sx={{ borderRadius: 24 }}
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </SkeletonWrapper>
  );
};

export default BookDetailsSkeleton;
